import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../../components/navbar";
import Switcher from "../../components/switcher";
import Footer from "../../components/footer";

export default function Terms(){
    return(
        <>
        <Navbar navclass="defaultscroll is-sticky" navlight={false} manuclass="justify-end"/>

        <section className="relative table w-full py-32 lg:py-40 bg-gray-50 dark:bg-slate-800">
            <div className="container relative">
                <div className="grid grid-cols-1 text-center mt-10">
                    <h3 className="text-3xl leading-normal font-semibold">Términos y Condiciones</h3>
                </div>
            </div>

            <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
                <ul className="tracking-[0.5px] mb-0 inline-block">
                    <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-red-500"><Link to="/">Chile-Turismo.cl</Link></li>
                    <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                    <li className="inline-block uppercase text-[13px] font-bold text-red-500" aria-current="page">Términos</li>
                </ul>
            </div>
        </section>

        <section className="relative md:py-24 py-16">
            <div className="container relative">
                <div className="md:flex justify-center">
                    <div className="md:w-3/4">
                        {/* Aviso de borrador legal */}
                        <div className="mb-6 p-4 rounded-md border border-amber-400 bg-amber-50 dark:bg-amber-500/10 text-amber-800 dark:text-amber-200 font-semibold text-center">
                            BORRADOR — pendiente de revisión legal
                        </div>

                        <div className="p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-md">
                            <p className="text-slate-400">
                                Estos Términos y Condiciones regulan el uso del sitio Chile-Turismo.cl y la contratación
                                de tours y experiencias ofrecidas a través de la plataforma. Al reservar o pagar un
                                servicio, declaras haber leído y aceptado estas condiciones.
                            </p>

                            <h5 className="text-xl font-semibold mb-4 mt-8">1. Objeto y aceptación</h5>
                            <p className="text-slate-400">
                                Chile-Turismo.cl actúa como plataforma de intermediación y/o venta de servicios turísticos.
                                La contratación de un tour implica la aceptación de estos términos, de la descripción
                                publicada del servicio (itinerario, duración, inclusiones y exclusiones) y de las
                                instrucciones entregadas por el operador o guía.
                            </p>

                            <h5 className="text-xl font-semibold mb-4 mt-8">2. Reservas y pagos</h5>
                            <p className="text-slate-400">
                                Las reservas se confirman una vez recibido el pago del anticipo o del total, según se
                                indique en cada tour. Los precios se expresan en pesos chilenos (CLP), salvo indicación
                                distinta. El cupo queda bloqueado por un tiempo limitado mientras se completa el pago;
                                vencido ese plazo sin pago, la reserva puede liberarse automáticamente.
                            </p>

                            <h5 className="text-xl font-semibold mb-4 mt-8">3. Cancelaciones y reembolsos</h5>
                            <p className="text-slate-400">
                                Las políticas de cancelación y reembolso se aplican conforme a la Ley N° 19.496 sobre
                                Protección de los Derechos de los Consumidores. Como referencia general, las cancelaciones
                                con menos de 48 horas de anticipación pueden no generar reembolso. Ante suspensiones por
                                causas de fuerza mayor (clima, cierre de senderos u otras), se ofrecerá reprogramación o la
                                devolución que corresponda según la ley.
                            </p>

                            <h5 className="text-xl font-semibold mb-4 mt-8">4. Check-in y firma digital</h5>
                            <p className="text-slate-400">
                                Antes del inicio del tour, el pasajero debe confirmar su asistencia mediante el proceso de
                                check-in en línea, que incluye la aceptación de una cláusula de participación y una firma
                                digital. Dicha firma tiene por objeto acreditar el conocimiento y la aceptación de las
                                condiciones de la actividad, incluyendo aspectos de seguridad y responsabilidad.
                            </p>

                            <h5 className="text-xl font-semibold mb-4 mt-8">5. Responsabilidad del pasajero</h5>
                            <p className="text-slate-400">
                                El pasajero declara encontrarse en condiciones físicas adecuadas para la actividad
                                contratada, seguir las indicaciones del guía y presentarse en el punto y hora de encuentro.
                                El incumplimiento de estas condiciones puede impedir la participación en el tour, sin
                                derecho a reembolso.
                            </p>

                            <h5 className="text-xl font-semibold mb-4 mt-8">6. Modificaciones del servicio</h5>
                            <p className="text-slate-400">
                                Por razones operativas, climáticas o de seguridad, el itinerario puede ajustarse. Se
                                procurará mantener la esencia del servicio contratado e informar oportunamente cualquier
                                cambio relevante.
                            </p>

                            <h5 className="text-xl font-semibold mb-4 mt-8">7. Legislación aplicable y jurisdicción</h5>
                            <p className="text-slate-400">
                                Estos términos se rigen por la legislación de la República de Chile. Cualquier controversia
                                se someterá a los tribunales competentes de Chile, sin perjuicio de los derechos que la ley
                                reconoce al consumidor.
                            </p>

                            <div className="mt-8">
                                <Link to="/" className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-red-500 hover:bg-red-600 border-red-500 hover:border-red-600 text-white rounded-md">Volver</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Switcher/>
        <Footer/>
        </>
    )
}
